import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Button from '../Button/'
import Link from '../Link'
import * as styles from './index.module.css'

const Os0Hero = ({
  title,
  subtitle,
  images,
  mobileOnlyImages,
  ctaText,
  ctaUrl,
}) => {
  let titleFrags = title.split(';')
  // assume the strategy is random if not fixed

  const isMobile = typeof window !== `undefined` && window.innerWidth <= 500
  const subtitleSegments = subtitle.subtitle.split('\n')
  const subtitleParts = subtitleSegments[0].split(';')
  const subtitleText = subtitleParts[0]
  const sensorType = subtitleParts[2]
  const subtitleColor = subtitleParts.length > 1 ? subtitleParts[1] : '#FFFFFF'
  const lableColor = titleFrags.length > 1 ? titleFrags[1] : '#FC9E21'
  let image = images[0]
  if (isMobile && mobileOnlyImages) {
    image = mobileOnlyImages[0]
  }

  return (
    <div className={styles.container}>
      <div className={styles.mobileHeader}>
        <h1 className={styles.label} style={{ color: lableColor }}>
          {sensorType}
        </h1>
        <div className={styles.title}>{titleFrags[0]}</div>
      </div>
      <div>
        <GatsbyImage
          image={image.iphero}
          className={styles.heroImage}
          alt={image?.description}
        />
      </div>

      <div className={`${styles.details} ${styles.nonmobile}`}>
        <h1 className={styles.label} style={{ color: lableColor }}>
          {sensorType}
        </h1>
        <div
          className={styles.title}
          style={{
            color: subtitleColor,
          }}
        >
          {titleFrags[0]}
        </div>

        <div className={`${styles.body} `} style={{ color: subtitleColor }}>
          {subtitleText}
        </div>
        <Link
          to={ctaUrl}
          children={<Button className={styles.joinUsButton}>{ctaText}</Button>}
        ></Link>
      </div>
      <div className={styles.mobileOnly}>
        <div className={`${styles.mobileBody}`}>{subtitleText}</div>
        <div className={styles.buttonContainer}>
          <Link
            to={ctaUrl}
            children={
              <Button className={styles.joinUsButton}>{ctaText}</Button>
            }
          ></Link>
        </div>
      </div>
    </div>
  )
}
export default Os0Hero
